import * as Yup from 'yup'

const deleteUserSchema = Yup.object().shape({
  userAcceptId: Yup.string().nullable().required('Please select user below.'),
})

export default deleteUserSchema
